import axios from 'axios';

const getCustomer = (options, pk) => {
  return axios.get('/crm/customers/' + pk + '/')
    .then(response => {
      options.commit('GET_CUSTOMER', response.data);
      return response.data.data;
    })
    .catch(error => {
      console.error('Erro ao buscar cliente:', error);
      throw error;
    });
};

const loadItems = (options, obj) => {
  if (!obj) {
    obj = {
      page: 'all',
      search: '',
    };
  }

  axios.get('/crm/customers/', {
    params: obj,
  }).then(response => {
    options.commit('SET_ITEMS', response.data);
  });
};


const addItem = (options, obj) => {
  let bodyFormData = new FormData();
  bodyFormData.append('obj', JSON.stringify(obj));
  axios.post('/crm/customers/create/' + (obj.isPF ? 'pf' : 'pj') + '/', bodyFormData).then(response => {
    options.commit('ADD_ITEM', response.data);
  });
};

const editItem = (options, obj) => {
  let bodyFormData = new FormData();
  bodyFormData.append('obj', JSON.stringify(obj));
  axios
    .post('/crm/customers/' + obj.pk + '/update/', bodyFormData)
    .then(response => {
      options.commit('EDIT_ITEM', response.data);
    });
};

const deleteItem = (options, obj) => {
  axios.post('/crm/customers/' + obj.pk + '/delete/').then(() => {
    options.commit('DELETE_ITEM', obj);
  });
};

export default { getCustomer, loadItems, addItem, editItem, deleteItem };
